module.exports = __webpack_public_path__ + "img/dps2.67bd5155.jpg";